export const FINANCE = 'Finance'
export const COMPANY = 'Company'
export const RM = 'RM'
export const MAIN_ADDRESS_TYPE = 'Main'
